import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling down 600px
      if (window.scrollY > 600) {
        // Hide if we reach the bottom offer section to avoid double buttons
        const offerSection = document.getElementById('offer-section');
        if (offerSection) {
          const rect = offerSection.getBoundingClientRect();
          if (rect.top < window.innerHeight) {
            setIsVisible(false);
            return;
          }
        }
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-185">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} className="fixed bottom-0 left-0 right-0 p-4 bg-white/90 backdrop-blur-md border-t border-slate-200 shadow-[0_-10px_40px_rgba(0,0,0,0.1)] z-50 md:hidden flex justify-center" data-id="element-186">
          <CTAButton className="w-full py-3 text-base" data-id="element-187" />
        </motion.div>}
    </AnimatePresence>;
}